import { useEffect, useState } from "react";
import { apiV2 } from "api/firebase";
import { Currency } from "@evennt-tech/api-v2-core";
import { IGetOneStripeConfigurationByCurrencyClientSecretRes } from "@evennt-tech/api-v2-external";
import { loadStripe, Stripe } from "@stripe/stripe-js";
import { useNetworkStatus } from "store/network-status/network-status.store";

export default (currency: Currency) => {
  const [stripe, setStripe] = useState<Stripe | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    useNetworkStatus.getState().setStripeCheckEnabled(true);
  }, []);

  useEffect(() => {
    setLoading(true);
    setError(null);

    (async () => {
      try {
        const config: IGetOneStripeConfigurationByCurrencyClientSecretRes = await apiV2.oldStripe.getOneStripeConfigurationByCurrencyClientSecret(
          {
            currency,
          }
        );

        if (!config) {
          throw new Error("Stripe configuration not found");
        }

        const stripeInstance = await loadStripe(config.clientSecret);
        setStripe(stripeInstance);
      } catch (e) {
        setError(e as Error);
        setStripe(null);
      } finally {
        setLoading(false);
      }
    })();
  }, [currency]);

  return { stripe, loading, error };
};
